{
    "ServerStatus_heading_applicationProperties": "Anwendungseigenschaften",
    "ServerStatus_action_refresh": "Aktualisierungsstatus",
    "NAME": "ServerStatusSprache"
}